/**
 * Métricas reales para TrialContinuationGate — omitir si count === 0 o falla.
 */
import {
  collection,
  getCountFromServer,
  query,
  where
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { trialDaysUsed } from './licenseUi';

async function countQuery(q) {
  try {
    const snap = await getCountFromServer(q);
    const n = Number(snap.data().count || 0);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

async function countCompanySub(orgId, sub) {
  if (!orgId) return null;
  return countQuery(collection(db, 'companies', orgId, sub));
}

async function countRootOrg(orgId, colName) {
  if (!orgId) return null;
  return countQuery(query(collection(db, colName), where('orgId', '==', orgId)));
}

/**
 * @returns {Promise<Array<{ key: string, label: string, value: number }>>}
 */
export async function loadTrialContinuationMetrics(orgId, lic) {
  const items = [];
  const days = trialDaysUsed(lic);
  if (days != null && days > 0) {
    items.push({ key: 'days', label: 'Días de prueba utilizados', value: days });
  }

  const pairs = [
    ['ventas', 'Ventas registradas', () => countRootOrg(orgId, 'ventas'), () => countCompanySub(orgId, 'ventas')],
    ['productos', 'Productos', () => countRootOrg(orgId, 'productos'), () => countCompanySub(orgId, 'productos')],
    ['clientes', 'Clientes', () => countRootOrg(orgId, 'clientes'), () => countCompanySub(orgId, 'clientes')],
    ['proveedores', 'Proveedores', () => countRootOrg(orgId, 'proveedores'), () => countCompanySub(orgId, 'proveedores')],
    ['usuarios', 'Usuarios', () => countCompanySub(orgId, 'usuarios'), null],
    ['sucursales', 'Sucursales', () => countCompanySub(orgId, 'sucursales'), () => countRootOrg(orgId, 'sucursales')],
    ['compras', 'Compras', () => countRootOrg(orgId, 'compras'), () => countCompanySub(orgId, 'compras')]
  ];

  let ventas = null;
  let compras = null;

  for (const [key, label, primary, fallback] of pairs) {
    let n = null;
    try {
      n = await primary();
      if (n == null && fallback) n = await fallback();
    } catch {
      n = null;
    }
    if (n != null && n > 0) {
      items.push({ key, label, value: n });
      if (key === 'ventas') ventas = n;
      if (key === 'compras') compras = n;
    }
  }

  const movimientos =
    (ventas || 0) + (compras || 0) > 0 ? (ventas || 0) + (compras || 0) : null;
  if (movimientos != null && movimientos > 0) {
    items.push({ key: 'movimientos', label: 'Movimientos comerciales', value: movimientos });
  }

  return items;
}
